import { useGtm } from '@gtm-support/vue-gtm'
import { useRoute } from 'nuxt/app'
import { type TRedirect } from '~/types/response-types'
import { type TPage } from '~/types/page-types'

export const useGTMPageView = (data: TPage | TRedirect) => {
  const route = useRoute()

  if (data) {
    let collection: string
    let title: string

    if ('collection' in data) {
      const pageData = data as TPage
      collection = pageData.collection
      title = pageData.title || 'unknown'
    } else {
      collection = title = 'redirect'
    }

    const gtm = useGtm()
    if (gtm) {
      console.log('ℹ GTM view tracked')
      const event = () => {
        gtm.trackView(collection, route.path, {
          pageTitle: title,
          pageUrl: route.path
        })
      }
      event()
    }
  }
}
